// extracted by mini-css-extract-plugin
module.exports = {"small":"FivaNavLayout_small__v_aeq","big":"FivaNavLayout_big__J2oX_"};